import {Pipe, PipeTransform} from '@angular/core'

@Pipe({
  name: 'bgoReplaceProps',
})
export class ReplacePropsPipe implements PipeTransform {
  transform(title: string, variables?: Record<string, string>): string {
    // If we don't have variables just return the title as it is.
    if (!variables) {
      return title
    }
    // look for all object keys marked with two curly braces in the title and replace them.
    for (const [key, value] of Object.entries(variables)) {
      title = title.replace(`{{${key}}}`, value)
    }
    return title
  }
}
